import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createAutocomplete } from '@algolia/autocomplete-core';
import React, { useContext } from 'react';
import { SearchModalAutocomplete, useSyncState } from '../../../components/search';
import { CentreContext, CentresContext } from '../../../context';
import { useIsRouteChanging } from '../../../next/router';
import { jsx as _jsx } from "react/jsx-runtime";
export const useSearchModalAutocomplete = (getSources, onSubmit, reshape) => {
  const {
    autocompleteState,
    onStateChange,
    resetState
  } = useSyncState();
  const [query, setQuery] = React.useState('');
  return React.useMemo(() => [{
    autocomplete: createAutocomplete({
      getSources,
      onStateChange,
      reshape,
      onSubmit: _ref => {
        let {
          event
        } = _ref;
        event.preventDefault();
        resetState();
        onSubmit(query);
      },
      openOnFocus: true
    }),
    autocompleteState,
    resetState,
    setNonDebouncedQuery: setQuery
  }, resetState], [autocompleteState, getSources, onStateChange, onSubmit, query, resetState, reshape]);
};
export const HeaderSearch = _ref2 => {
  let {
    isOpen = false,
    onClose,
    getSources,
    centres,
    country,
    specialSearchKind,
    onSubmit,
    reshape
  } = _ref2;
  const centre = useContext(CentreContext);
  const isRouteChanging = useIsRouteChanging();
  const [autocomplete, resetState] = useSearchModalAutocomplete(getSources !== null && getSources !== void 0 ? getSources : () => [], onSubmit !== null && onSubmit !== void 0 ? onSubmit : () => {}, reshape !== null && reshape !== void 0 ? reshape : () => {});
  React.useEffect(() => {
    if (isRouteChanging) {
      onClose === null || onClose === void 0 || onClose();
      resetState();
    }
  }, [isRouteChanging, onClose, resetState]);
  return /*#__PURE__*/_jsx(CentresContext.Provider, {
    value: (centres !== null && centres !== void 0 ? centres : []).map(centre => _objectSpread(_objectSpread({}, centre), {}, {
      sys: {
        id: ''
      },
      status: '',
      country: '',
      timeZone: '',
      centreFrontImage: null
    })),
    children: /*#__PURE__*/_jsx(SearchModalAutocomplete, {
      baseContext: {
        centre,
        country,
        user: undefined,
        // TODO: is it used? Should restrict shape to only fields that are in use
        specialSearchKind
      },
      onClickClose: () => {
        onClose === null || onClose === void 0 || onClose();
        resetState();
      },
      autocompleteWithState: autocomplete,
      isOpen: isOpen,
      backgroundColor: "surfaceBrandPrimary",
      "data-id": "header-search_index_HeaderSearch_SearchModalAutocomplete"
    })
  });
};